import { useState } from 'react';
import { clsx } from 'clsx';
import { Icon } from '@/ui/icons/Icon';
import styles from './OfferFaq.module.scss';

export interface OfferFaqItem {
  question: string;
  answer: string[];
  // Listed after the paragraphs.
  bullets?: string[];
}

interface OfferFaqProps {
  items: OfferFaqItem[];
  className?: string;
}

export function OfferFaq({ items, className }: OfferFaqProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className={clsx(styles.root, className)}>
      {items.map((item, index) => {
        const isOpen = openIndex === index;

        return (
          <div key={item.question} className={styles.item}>
            <button
              type="button"
              className={clsx(styles.question, isOpen && styles['question--open'])}
              aria-expanded={isOpen}
              onClick={() => setOpenIndex(isOpen ? null : index)}
            >
              <span className={styles.questionText}>{item.question}</span>
              <Icon
                name="angle-down"
                size={20}
                className={clsx(styles.angle, isOpen && styles['angle--open'])}
              />
            </button>
            {isOpen && (
              <div className={styles.answer}>
                {item.answer.map((paragraph) => (
                  <p key={paragraph} className={styles.paragraph}>
                    {paragraph}
                  </p>
                ))}
                {item.bullets && (
                  <ul className={styles.bullets}>
                    {item.bullets.map((bullet) => (
                      <li key={bullet}>{bullet}</li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
